// extracted by mini-css-extract-plugin
export default {"root":"fU6rrj8_3BZWS5qdYQzb"};